import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NewsItem } from '../../../services/news-items/news-items';
import { NewsItemsService } from '../../../services/news-items/news-items.service';
import { NewsItemCardComponent } from '../news-item-card/news-item-card.component';

@Component({
    selector: 'app-newsletter-archive',
    imports: [RouterModule, NewsItemCardComponent],
    templateUrl: './newsletter-archive.component.html',
    styleUrl: './newsletter-archive.component.css'
})
export class NewsletterArchiveComponent implements OnInit {
  newsletters: NewsItem[] = [];

  constructor(private newsItemsService: NewsItemsService) {}

  ngOnInit(): void {
    this.newsItemsService.getNewsItems({ displayIn: 'newsletter-archive' }).subscribe(items => {
      this.newsletters = items.sort(
        (a, b) => new Date(b.datePosted).getTime() - new Date(a.datePosted).getTime()
      );
    });
  }
}
